<template>
  <div class="noAlTope">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <b-row class="text-center">
      <b-col class="col-md-4">
        <br /><br />
        <label>Id Paciente:</label>
        <b-form-input
          v-model="idPaciente"
          type="number"
          placeholder="Ingrese el id del paciente"
        ></b-form-input>
        <br />
        <b-button block variant="success" @click="buscarNombreIdPaciente"
          >Verificar</b-button
        >
      </b-col>
      <b-col class="col-md-8">
        <br /><br />

        <label>Nombre paciente:</label>
        <b-form-input
          disabled
          v-model="nombrePaciente"
          placeholder="Nombre del paciente"
        ></b-form-input>
        <br /><br />
      </b-col>
    </b-row>

    <b-row class="text-left">
      <b-col class="col-md-4">
        <br />
      </b-col>

      <b-col class="col-md-4">
        <br /><br />
        <div>
          <b-list-group>
            <b-list-group-item
              ><b-form-checkbox v-model="presupuestos"
                >Presupuestos</b-form-checkbox
              ></b-list-group-item
            >
            <b-list-group-item
              ><b-form-checkbox v-model="programados"
                >Programados</b-form-checkbox
              ></b-list-group-item
            >
            <b-list-group-item
              ><b-form-checkbox v-model="saldo">Saldo</b-form-checkbox>
            </b-list-group-item>
          </b-list-group>

          <div>
            <br /><br />

            <b-button
              block
              variant="success"
              @click="migrarDatos"
              v-if="
                this.idPaciente != null &&
                this.idPaciente != '' &&
                this.nombrePaciente != null &&
                this.nombrePaciente != ''
              "
              >Migrar Datos</b-button
            >
            <br /><br />
          </div>
        </div>
        <br /><br />
      </b-col>
    </b-row>



  <b-modal
      ref="respuestaProceso"
      title="Migración finalizada"
      hide-footer
    > 
       <b-table
        thead-tr-class="columnas"
        :items="respuesta"
        :fields="encabezados"
        class="parrafos"
        responsive
      >
         
      </b-table>
      
      <br /><br />
    </b-modal>
    
    
    <b-row class="text-center">
      <b-col> <br /><br /><br /><br /><br /><br /> </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "AdministracionMigraciones",
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    idPaciente: null,
    nombrePaciente: null,
    presupuestos: false,
    programados: false,
    saldo: false,
    loading: false,
    respuesta : [],
    encabezados: [
      { key: "nombreFuncion", label: "Migración" },
      { key: "respuesta", label: "Respuesta", sortable: true },
     
    ],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    buscarNombreIdPaciente() {
      this.loading = true;
      this.nombrePaciente = null;
      const params = {
        idPaciente: this.idPaciente
      }
      this.$http
        .post(this.$api + "paciente/obtenerDatosPacienteId", params)
        .then((response) => {
          if (response.status === 200) {
            var nacimiento = (response.data.data.fechaNacimiento = moment(
              response.data.data.fechaNacimiento
            )
              .utc()
              .format("DD/MM/YYYY"));
            this.nombrePaciente =
              response.data.data.nombre + " (" + nacimiento + " )";
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => (this.loading = false));
    },

    migrarDatos() {
      this.respuesta = [];
      if (this.idPaciente == null && this.idPaciente != "") {
        this.$swal({
          icon: "error",
          text: "Favor de ingresar el id del paciente",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
      } else {
        if (
          this.presupuestos == false &&
          this.programados == false &&
          this.saldo == false
        ) {
          this.$swal({
            icon: "error",
            text: "Favor de seleccionar una opción",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
        } else {
          var params = {
            idPaciente: this.idPaciente,
            presupuestos: this.presupuestos,
            programados: this.programados,
            saldo: this.saldo,
          };

          this.loading = true;

          this.$http
            .post(this.$api + "funcionespostgresql/migraciondatos", params)
            .then((response) => {
              if (response.status === 200) {
                this.respuesta = response.data.data.respuesta;  
                this.$refs['respuestaProceso'].show();
                 
              }
            })
            .catch((err) => {
              console.error(err);
              this.loading = false;
              this.$swal({
                icon: "error",
                text: "Ocurrió un error durante el proceso.",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
  },
};
</script>